import { bindable } from 'aurelia-framework';
export class TaskDetails {
	@bindable controller;
	//isEditing: boolean = false;
	edit() {
		this.controller.isEditingDetails = true;
	}
	save() {
		this.controller.isEditingDetails = false;
		this.controller.saveItem(this.controller.item);
	}
	cancel() {
		this.controller.isEditingDetails = false;
		this.controller.cancelEdit(this.controller.item);
	}	
}